import React from 'react';
import DirectorDashboard from './DirectorDashboard';

export default function TeacherDashboard() {
  return <DirectorDashboard />;
}
